import Assert from "tbAssert";
import ngAnimate from "angular-animate";
import ngAria from "angular-aria";
import uiBootstrap from "angular-ui-bootstrap";
import CalendarGlobalViewServiceModule from "tbClient/services/CalendarGlobalViewService";
import GlobalViewChangeDialogController from "./global-view-change-dialog/GlobalViewChangeDialogController";

import DependencyListBuilder from "tbClient/utility/DependencyListBuilder";

const gvChangeDialogBackdropClass = "tbIn";
const gvChangeDialogWindowClass = "tbIn";

class GlobalViewUiController {
    constructor($log, $scope, $timeout, $uibModal, CalendarGlobalViewService) {
        this._logSvc = $log;
        this._scopeSvc = $scope;
        this._timeoutSvc = $timeout;
        this._uibModalSvc = $uibModal;
        this._globalViewSvc = CalendarGlobalViewService;
        this._currentView = null;
        this._availableViews = [];
        this._viewMenuIsOpen = false;
    }

    _reloadViews() {
        this._globalViewSvc.reload();
        this._loadAvailableViews();
        this._logSvc.debug("global view ui controller: _reloadViews");
    }

    _loadAvailableViews() {
        this._logSvc.debug("global view ui controller: reloading available Views", this._availableViews);
        const availableViewInfo = this._globalViewSvc.availableGlobalViews;
        this._availableViews.splice(0, this._availableViews.length, ...availableViewInfo);
        this._logSvc.debug("global view ui controller: available Views after reload", this._availableViews);
    }

    get availableViews() {
        return this._availableViews;
    }

    get selectedView() {
        return this._currentView;
    }

    _reloadCurrentView() {
        const currentView = this._globalViewSvc.getCurrentView();
        this._logSvc.debug("looked up current view", currentView);
        this._currentView = currentView;
    }

    $onInit() {
        this._logSvc.debug("global view ui controller: onInit");
        this._reloadViews();
        this._reloadCurrentView();

        this._scopeSvc.$watch(() => this._globalViewSvc.getCurrentView(), (newVal, oldVal) => {
            if (newVal["name"] !== oldVal["name"]) {
                this._reloadCurrentView();
            }
        });
    }

    changeView(viewName) {
        this._logSvc.debug(`global view ui controller: changeView to ${viewName}`);
        if (this._currentView.name !== viewName) {
            this._globalViewSvc.changeCurrentView(viewName);
            //$watch will handle this
            //this._reloadCurrentView();
        }
    }

    runChangeViewFlow() {
        const changeViewDialogModal = this._uibModalSvc.open({
            animation: true,
            template: GlobalViewChangeDialogController.template,
            controller: GlobalViewChangeDialogController,
            controllerAs: GlobalViewChangeDialogController.controllerAs,
            bindToController: true,
            backdropClass: gvChangeDialogBackdropClass,
            windowClass: gvChangeDialogWindowClass,
            resolve: {}
        });

        //Create local references to instance member variables and the instance itself for async closure capture;
        const changeViewFn = this.changeView;
        const logSvc = this._logSvc;
        const ctrl = this;

        changeViewDialogModal.result
            .then((changeDialogResult) => {
               this._logSvc.debug("global view ui controller: change view dialog result", changeDialogResult);
               if (changeDialogResult.status === GlobalViewChangeDialogController.results.OK) {
                   Assert.StrictAssert(
                       typeof changeDialogResult.selectedView === "string",
                       "gvChangeViewDialog Ok Handling: Unexpected result type");
                   // Calling controller function from an async function, so need
                   // to allow AngularJS to manage when this gets executed.
                   this._timeoutSvc(() => {
                       logSvc.debug("calling change view from dialog result promise");
                       // JS at its finest!
                       changeViewFn.call(ctrl, changeDialogResult.selectedView);
                   }, 0);
               }
               else {
                   this._logSvc.error("gvChangeViewDialog returned unexpected success result", changeDialogResult);
                   throw new Error("gvChangeViewDialog returned unexpected success result");
               }
            })
            .catch((changeDialogErr) => {
                if (changeDialogErr === GlobalViewChangeDialogController.results.CANCEL) {
                    this._logSvc.debug("User cancelled change global view dialog");
                }
                else {
                    this._logSvc.error("Global View Change Dialog error", changeDialogErr);
                    throw new Error("Error during change view dialog workflow");
                }
            });
    }

    toggleView() {
        this._reloadViews();
        const currentViewIdx = this.availableViews.findIndex((view) => view.name === this.selectedView.name);
        if (currentViewIdx < 0) {
            this._logSvc.debug("toggle global view: could not locate current view");
            return;
        }
        const nextViewIdx = (currentViewIdx + 1) % this.availableViews.length;
        const nextView = this.availableViews[nextViewIdx];
        this._logSvc.debug("toggle global view: next view selected", nextView);
        this.changeView(nextView.name);
    }
}

GlobalViewUiController.$inject = [
    "$log",
    "$scope",
    "$timeout",
    "$uibModal",
    "CalendarGlobalViewService"
];
GlobalViewUiController.dependencies = DependencyListBuilder([
    GlobalViewChangeDialogController.dependencies,
    [
        CalendarGlobalViewServiceModule,
        ngAnimate,
        ngAria,
        uiBootstrap
    ]
]);
GlobalViewUiController.controllerAs = "globalViewCtrl";
GlobalViewUiController.template = require("./GlobalViewUi.tpl.html");

export default GlobalViewUiController;



//////////////////
// WEBPACK FOOTER
// ./src/directives/GlobalViewUi/GlobalViewUiController.js
// module id = cY/w
// module chunks = 1